import {
	CustomLength,
	type CustomLengthType,
	CustomTone,
	type CustomToneType,
} from '../types/customizationTypes';

// Helper functions to convert GraphQL enum values to CustomToneType/CustomLengthType
export const convertConfluenceToneToCustomTone = (
	tone: string | null | undefined,
): CustomToneType | undefined => {
	if (!tone) {
		return undefined;
	}
	const normalizedTone = String(tone).trim().toLowerCase();
	return Object.values(CustomTone).includes(normalizedTone as CustomToneType)
		? (normalizedTone as CustomToneType)
		: undefined;
};

export const convertConfluenceLengthToCustomLength = (
	length: string | null | undefined,
): CustomLengthType | undefined => {
	if (!length) {
		return undefined;
	}
	const normalizedLength = String(length).trim().toLowerCase();
	return Object.values(CustomLength).includes(normalizedLength as CustomLengthType)
		? (normalizedLength as CustomLengthType)
		: undefined;
};
